import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ActionLink from "../../../../controls/ActionLink";
import CompanyProductRow from "./CompanyProductRow";

class CompanyProductTable extends Component {
    static propTypes = {
        products: PropTypes.array.isRequired,
        taxTypes: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        products: this.props.products
    };

    componentWillReceiveProps({products}) {
        if (products.length != this.props.products.length)
            this.setState({products});
    }

    render() {
        const {taxTypes, ...props} = this.props;
        return (
            <div>
                <div className="m-b-2" style={{overflowX: 'scroll'}}>
                    <table className="table table-striped m-b-0">
                        <thead>
                        <tr>
                            <th style={{minWidth: '150px'}}>Код артикула*</th>
                            <th style={{minWidth: '150px'}}>Название артикула</th>
                            <th style={{minWidth: '150px'}}>Мощность</th>
                            <th style={{minWidth: '150px'}}>Желаемая цена*</th>
                            <th style={{minWidth: '120px'}}>Условия оплаты</th>
                            <th style={{minWidth: '150px'}}>Согласованная цена*</th>
                            <th style={{minWidth: '120px'}}>Условия оплаты</th>
                            <th style={{minWidth: '150px'}}>Комментарии</th>
                            <th/>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.products.length
                                ? this.state.products.map((product, i) =>
                                    <CompanyProductRow key={i} data={product} taxTypes={taxTypes}
                                                       onUpdate={product => this.updateProduct(i, product)}
                                                       onRemove={() => this.removeProduct(i)}/>
                                )
                                : <tr>
                                    <td className="text-center" colSpan="9">
                                        Позиции продукции отсутствуют. Нажмите кнопку
                                        {' '}
                                        <ActionLink onClick={() => this.createProduct()}>
                                            Добавить позицию
                                        </ActionLink>
                                        {' '}
                                        для создания.
                                    </td>
                                </tr>
                        }
                        </tbody>
                    </table>
                </div>
                <button type="button" className="btn btn-default btn-outline"
                        onClick={() => this.createProduct()}>
                    <i className="fa fa-plus"/> Добавить позицию
                </button>
            </div>
        );
    }

    createProduct() {
        const {products} = this.state;

        products.push({
            product: null,
            productId: 0,
            count: '',
            desiredPrice: '',
            desiredPriceTypeId: 0,
            agreedPrice: '',
            agreedPriceTypeId: 0,
            comment: '',
        });

        this.setState({products});
    }

    updateProduct(index, product) {
        const {onChange} = this.props;
        const {products} = this.state;

        products[index] = product;

        this.setState({products}, () => onChange(this.state.products));
    }

    removeProduct(index) {
        let products = this.state.products;

        products.splice(index, 1);
        this.setState({products});
    }
}

export default CompanyProductTable;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/components/CompanyProductTable.js